import { render, staticRenderFns } from "./LabInfo.vue?vue&type=template&id=d8de06bc&scoped=true&"
import script from "./LabInfo.vue?vue&type=script&lang=js&"
export * from "./LabInfo.vue?vue&type=script&lang=js&"
import style0 from "./LabInfo.vue?vue&type=style&index=0&id=d8de06bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8de06bc",
  null
  
)

export default component.exports